// ------------------------------------------------------------
//  Shared Postgres helper : stream ND-JSON from /records/<tbl>
// ------------------------------------------------------------
import api from "./api";          // central Axios instance (baseURL + JWT)

/*─────────────────────────────────────────────────────────────┐
│  A tiny bridge: the FilterProvider (next file) registers a  │
│  getter so we can read the *latest* { connIds, compIds }    │
│  without using React hooks inside this plain JS module.     │
└─────────────────────────────────────────────────────────────*/
let _filterGetter = () => ({ connIds: [], compIds: [] });
export function _attachFilterGetter(fn) {
  if (typeof fn === "function") _filterGetter = fn;
}

/**
 * Stream ND-JSON from `/records/<table>` and return it as an array.
 *
 * @param {string}   table                 – DB view name
 * @param {number[]} [connIds]             – override DB ids (else global filter)
 * @param {number[]} [compIds]             – override company ids (else global)
 * @param {number}   [limit   = 5000]      – max rows
 * @returns {Promise<object[]>}
 */
export async function fetchTable(
  table,
  connIds = undefined,
  compIds = undefined,
  limit   = undefined,
) {
  /* fallback to the live filter state when callers pass nothing  */
  if (connIds === undefined || compIds === undefined) {
    const global = _filterGetter();
    if (connIds === undefined) connIds = global.connIds;
    if (compIds === undefined) compIds = global.compIds;
  }

  /* build query-string */
  const qs = new URLSearchParams();
  // add ?limit=N only when N > 0
  if (limit !== undefined) qs.set("limit", limit);
  (connIds || []).forEach(id => qs.append("conn_ids", id));
  (compIds || []).forEach(cc => {
    // dashboards pass "<dbId>:<compId>" – back-end needs only compId
    const id = typeof cc === "string" ? cc.split(":")[1] : cc;
    qs.append("company_ids", id);
  });

  /* hit the fast-API backend (baseURL + JWT already set in api) */
  const suffix = qs.toString() ? `?${qs}` : "";
  const { data: text } = await api.get(`/records/${table}${suffix}`, {
    responseType: "text",          // keep raw ND-JSON
  });

  return text.trim() ? text.trim().split("\n").map(JSON.parse) : [];
}
